const setFeatures = (state, selectedFeatures) => {
  state.selectedFeatures = selectedFeatures
}
export default {
  setRoles: (state, roles) => {
    state.roles = roles
  },
  setShowRolesModal: (state, showRolesModal) => {
    state.showRolesModal = showRolesModal

    if (!showRolesModal) {
      state.isSelectAllFeatures = false
    }
  },
  setEditedItemIndex: (state, editedItemIndex) => {
    state.editedItemIndex = editedItemIndex
  },
  setEditedItem: (state, editedItem) => {
    state.editedItem = editedItem
  },
  setRoleDetails: (state, roleDetails) => {
    state.roleDetails = roleDetails
    state.roleDetails.features.forEach(value => {
      state.selectedFeatures.push(value.featureId)
    })
  },
  setSelectedFeatures: (state, selectedFeatures) => {
    setFeatures(state, selectedFeatures)
  },
  updateRoleDetails: (state, data) => {
    if (!(data.key in state.roleDetails)) {
      state.roleDetails = {
        ...state.roleDetails,
        [data.key]: data.value
      }
    } else {
      state.roleDetails[data.key] = data.value
    }
  },
  resetRoleDetails: (state, data) => {
    state.roleDetails = {
      roleId: null,
      roleName: null,
      roleDescription: null,
      clientId: '',
      clientName: null,
      clientNameDesc: null,
      featureCnt: null,
      createdBy: null,
      createdOn: null,
      lastModifiedBy: null,
      lastModifiedOn: null,
      recInactiveFlag: null,
      features: []
    }
    state.editedItemIndex = -1
    state.selectedFeatures = []
  },
  selectAllFeatures: (state, value) => {
    const features = []
    state.isSelectAllFeatures = value
    if (value) {
      state.features.landing.forEach(feature => {
        features.push(feature.featureId)

        if (feature.viewFeatureId) {
          features.push(feature.viewFeatureId)
        }
        if (feature.updateFeatureId) {
          features.push(feature.updateFeatureId)
        }
        if (feature.addFeatureId) {
          features.push(feature.addFeatureId)
        }
      })
      state.features.view.forEach(feature => {
        if (feature.viewFeatureId) {
          features.push(feature.viewFeatureId)
        }
        if (feature.updateFeatureId) {
          features.push(feature.updateFeatureId)
        }
        if (feature.addFeatureId) {
          features.push(feature.addFeatureId)
        }
      })
    }
    setFeatures(state, features)
  }
}
